import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const SlideCarouselWrapper = styled.div``;

export const SlideCarouselPagination = styled.ul`
  display: inline-flex;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0;
`;

type SlideCarouselPageProps = {
  $active: boolean;
};

export const SlideCarouselPage = styled.li<SlideCarouselPageProps>`
  display: inline-block;
  width: 8px;
  height: 8px;
  background: ${({ $active, theme }) => ($active ? theme.primaryBackgroundColor : ColorPalette.HEX.LavenderGray)};
  border-radius: 50%;
  margin: 2px;
  padding: 0;
  transition: transform 0.2s linear;
  border: none;

  &:hover {
    cursor: pointer;
    opacity: 0.9;
  }

  &:focus {
    outline: none;
  }
`;
